module.exports = __webpack_public_path__ + "ptc_momoro_P2.f6d364cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_P2.jpg
// module id = DO6F
// module chunks = 0